export default __webpack_public_path__ + "static/media/g_plus.9e3b0601.svg";